/**
 * External Dependencies
 */
import classnames from 'classnames'; //npm install classnames --save
import assign from 'lodash.assign';

/* https://jeffreycarandang.com/extending-gutenberg-core-blocks-with-custom-attributes-and-controls/ */
/* https://wordpress.stackexchange.com/questions/376894/ */

/**
 * WordPress Dependencies
 */
const { __ } = wp.i18n;
const { addFilter } = wp.hooks;
const { Fragment }	= wp.element;
const { InspectorControls }	= wp.blockEditor;
const { PanelBody} = wp.components;
const { createHigherOrderComponent } = wp.compose;
const {__experimentalLinkControl: LinkControl} = wp.blockEditor;

//restrict to specific block names
const allowedBlocks = [ 'core/columns', 'core/column' ];

/**
 * Add custom attribute for wrapping blocks in links.
 *
 * @param {Object} settings Settings for the block.
 *
 * @return {Object} settings Modified settings.
 */
function addAttributes( settings ) {

	//check if object exists for old Gutenberg version compatibility
	//add allowedBlocks restriction
	if( typeof settings.attributes !== 'undefined' && allowedBlocks.includes( settings.name ) ){

		const amountDefault = [
		    {
		        title: '',
		        url: '',
		        opensInNewTab: false,
		        id: 0,
		    },

		];

		settings.attributes = Object.assign( settings.attributes, {
		    wrapperLinkItems: {
		        type: 'array',
		        default: amountDefault,
		    },
		});

	}

	return settings;
}

/**
 * Add link wrapping controls on Advanced Block Panel.
 *
 * @param {function} BlockEdit Block edit component.
 *
 * @return {function} BlockEdit Modified block edit component.
 */
const withAdvancedControls = createHigherOrderComponent( ( BlockEdit ) => {
	return ( props ) => {

		const {
			name,
			attributes,
			setAttributes,
			isSelected,
            clientId,
		} = props;

		const {
			value,
			item,
			wrapperLinkItems,
			index,
			opensInNewTab,
		} = attributes;

		const amountDefault = [
		    {
		        title: null,
		        url: null,
		        opensInNewTab: false,
		        id: 0,
		    },

		];

		return (
			<Fragment>
				<BlockEdit {...props} />
				{ isSelected && allowedBlocks.includes( name ) &&
					<InspectorControls>
					<PanelBody
					title={__('Link', 'awp')}
					initialOpen={ false }
					>
					{wrapperLinkItems.map((item, index) => (
					<LinkControl
					        value={ { ...item } }
							key={ item+clientId }
					        onChange={ ( value ) => {
					            // do not change the existing 'wrapperLinkItems' array; clone it instead
					            //const newItems = [ ...wrapperLinkItems ];
					            const newItems = [ ...amountDefault ];

					            // then update the one being edited
					            // the 'index' below is the one passed to .map() above
					            newItems[ index ] = { ...newItems[ index ], ...value };

								if (newItems[0].url !== '/'){

									// If it is an external link remove the title and type
									if (newItems[0].id == 0){
										newItems[0].title = null;
										delete newItems[0].type;
									}

						            // then update the block attributes
						            setAttributes( { wrapperLinkItems: newItems } );
								}else{
									setAttributes( { wrapperLinkItems: amountDefault } );
								}

					            //console.log( value, newItems, wrapperLinkItems ); // for testing/debugging
					            //console.log( newItems ); // for testing/debugging
					        } }
					    />
					))}
					</PanelBody>
					</InspectorControls>
				}

			</Fragment>
		);
	};
}, 'withAdvancedControls');

/**
 * Add custom element class in save element.
 *
 * @param {Object} extraProps     Block element.
 * @param {Object} blockType      Blocks object.
 * @param {Object} attributes     Blocks attributes.
 *
 * @return {Object} extraProps Modified block element.
 */
function wrapWithLink( extraProps, blockType, attributes ) {

	const { wrapperLinkItems } = attributes;

	//check if attribute exists for old Gutenberg version compatibility
	//add class only when url = false
	//add allowedBlocks restriction
	if ( typeof wrapperLinkItems !== 'undefined' && (typeof wrapperLinkItems.isArray === 'undefined') && allowedBlocks.includes( blockType.name ) ) {

		if (wrapperLinkItems[0].url){
			extraProps.className = classnames( extraProps.className, 'link-present' );
	        assign( extraProps, { 'data-link-url': wrapperLinkItems[0].url } );
	        assign( extraProps, { 'data-link-target': wrapperLinkItems[0].opensInNewTab } );
		}

	}

	return extraProps;
}

//add filters

addFilter(
	'blocks.registerBlockType',
	'pwd-blocks/custom-attributes',
	addAttributes
);

addFilter(
	'editor.BlockEdit',
	'pwd-blocks/custom-advanced-control',
	withAdvancedControls
);

addFilter(
	'blocks.getSaveContent.extraProps',
	'pwd-blocks/wrapWithLink',
	wrapWithLink
);